var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leilao-tipo-label",class:'l-tipo-' + _vm.tipoCode},[_vm._v(" "+_vm._s(_vm.tipoTitle)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }